import { render, staticRenderFns } from "./ColorContrastWarning.vue?vue&type=template&id=4474210e"
import script from "./ColorContrastWarning.vue?vue&type=script&lang=js"
export * from "./ColorContrastWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports